import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CardActions from "@material-ui/core/CardActions";
import {
  TextField,
  ShowController,
  ShowView,
  SimpleShowLayout,
  ReferenceField,
  FunctionField,
  ListButton,
  DeleteButton,
  RefreshButton,
  EditButton,
  FormDataConsumer,
} from "react-admin";
import semver from "semver";

import KioskTitle from "./kioskTitle";
import AlertListField from "../containers/alertListField";
import ActivityDetailField from "../containers/activityDetailField";
import ConnectButton from "./connectButton";
import DisconnectButton from "./disconnectButton";
import LogDownloadActions from "./logDownloadActions";

import { idStatusToText } from "../lib/kioskPresentation";
import { hasActionsRights } from "../lib/permissions";

const KioskShowActions = ({
  classes,
  permissions,
  basePath,
  data,
  resource,
}) => (
  <CardActions className={classes.actionCard}>
    <ListButton basePath={basePath} />
    {permissions === "super_admin" && (
      <DeleteButton basePath={basePath} record={data} resource={resource} />
    )}
    {permissions === "super_admin" && (
      <EditButton basePath={basePath} record={data} />
    )}
    <RefreshButton />
  </CardActions>
);

const versionIsValid = version => {
  if (!version) return false;
  const compare = version
    .split(".")
    .slice(0, 3)
    .join(".");
  return semver.gt(compare, "0.0.0");
};

const KioskShow = ({ classes, permissions, ...props }) => (
  <ShowController {...props}>
    {controllerProps => (
      <ShowView
        {...props}
        {...controllerProps}
        actions={
          // eslint-disable-next-line
          <KioskShowActions
            permissions={permissions}
            classes={classes}
            {...props}
          />
        }
        classes={classes}
        title={<KioskTitle />}
      >
        <SimpleShowLayout>
          <TextField source="title" label="Nom" />
          <TextField source="serialno" label="Borne identifier" />
          {permissions === "super_admin" && (
            <ReferenceField
              label="Station"
              source="stationid"
              reference="stations"
              linkType="show"
            >
              <TextField source="location" />
            </ReferenceField>
          )}
          <FunctionField
            label="Statut"
            render={record =>
              idStatusToText(classes, record.status, record.alertstatus)
            }
          />
          <AlertListField label="Dernières alertes" />
          <ActivityDetailField label="Activité" />
          <FormDataConsumer>
            {({ formData }) =>
              hasActionsRights(permissions) &&
              versionIsValid(formData.softwareversion) && (
                <LogDownloadActions
                  label="logs"
                  kiosk={controllerProps.record}
                />
              )
            }
          </FormDataConsumer>
          {hasActionsRights(permissions) && (
            <div className={classes.buttonContainer}>
              <ConnectButton kiosk={controllerProps.record} />
              <DisconnectButton kiosk={controllerProps.record} />
            </div>
          )}
        </SimpleShowLayout>
      </ShowView>
    )}
  </ShowController>
);

const styles = () => ({
  buttonContainer: {
    marginTop: 5,
  },
  actionCard: {
    zIndex: 2,
    display: "inline-block",
    float: "right",
  },
});

export default withStyles(styles)(KioskShow);



// WEBPACK FOOTER //
// ./src/components/kioskShow.js